import { Heading } from 'components/Heading'
import React, { ReactNode } from 'react'
import styled, { css, useTheme } from 'styled-components'

export const cardStyles = css`
	width: 100%;
	&.__gutter {
		.card-inner {
			padding: ${props => props.theme?.sizes?.gutter?.mobile?.val}
				${props => props.theme?.sizes?.gutter?.mobile?.val} 10px
				${props => props.theme?.sizes?.gutter?.mobile?.val};
		}
	}
	&.__bottom-padding {
		padding-bottom: ${props => props.theme?.sizes?.gutter?.mobile?.val};
	}
	&.__shadow-card {
		.card-inner {
			box-shadow: 0px 3.5px 3.5px 0px ${props => props.theme?.colors?.midNeutral?.opacity(40).val};
		}
	}
	&.__border-card {
		.card-inner {
			border-top: 2px solid ${props => props.theme?.colors?.primary?.val};
			border-bottom: 2px solid ${props => props.theme?.colors?.primary?.val};
			padding: ${props => props.theme?.sizes?.gutter?.mobile?.val} 0;
		}
	}
	&.__white-bg {
		.card-inner {
			background: ${props => props.theme?.colors?.white?.val};
		}
	}
`

const CardView = styled.div`
	${cardStyles}
`

export type CardProps = {
	children: ReactNode
	className?: string
	type?: 'shadow' | 'line' | 'none'
	background?: 'none' | 'white'
	title?: string
	padBottom?: boolean
	hasGutter?: boolean
}
export const Card = ({
	className,
	type = 'shadow',
	background = 'white',
	title,
	padBottom = true,
	hasGutter,
	children,
}: CardProps) => {
	const theme = useTheme()
	return (
		<CardView
			className={`card${className ? ` ${className}` : ''}${
				type === 'shadow' ? ' __shadow-card' : type === 'line' ? ' __border-card' : ''
			}${background === 'white' ? ' __white-bg' : background === 'none' ? ' __no-bg' : ''}${
				padBottom ? ' __bottom-padding' : ''
			}${hasGutter ? ' __gutter' : ''}`}
			theme={theme}
		>
			<div className='card-inner'>
				{title ? <Heading displayType='block-heading'>{title}</Heading> : ''}
				{children}
			</div>
		</CardView>
	)
}
